module["exports"] = [];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/it/name/suffix.js
 ** module id = 780
 ** module chunks = 0
 **/